import React, { FC } from 'react';
import { Input } from '@cokitchen/cokitchen-components';
import { ENUM_STATUS } from '../../helpers/enums';
import useLayoutContext from '../../contexts/layout.context';
import { getShouldShowCheckbox, statusIsPackaging } from '../../helpers/permissions.service';

type CutleryType = {
  onChange: () => void;
  status: ENUM_STATUS;
  isChecked: boolean;
  hasCutlery: boolean;
};

const Cutlery: FC<CutleryType> = ({ onChange, hasCutlery, isChecked, status }) => {
  const { permissions } = useLayoutContext();
  const { showCheckbox } = permissions;
  const shouldShowChecbox = getShouldShowCheckbox({ status, showCheckbox });
  return (
    <div
      className={`flex justify-start items-center ${
        statusIsPackaging(status) ? 'cursor-pointer' : ''
      }`}
      onClick={onChange}>
      <p className='text-[#595959] py-1 mb-0 bg-[#F5F5F5] px-3 rounded-full'>
        Cutlery:
        <span className={`ml-[3px] mr-0 ${hasCutlery ? 'text-[#016FB1]' : 'text-red-4'}`}>
          {hasCutlery ? 'Yes' : 'No'}
        </span>
      </p>
      {shouldShowChecbox && hasCutlery && (
        <span className='ml-3'>
          <Input type='checkbox' checkColor='green' checked={isChecked} onChange={onChange} />
        </span>
      )}
    </div>
  );
};

export default Cutlery;
